import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import httpClient from './auth/httpClient';

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH+'/api';
const registerUrl = process.env.REACT_APP_API_ENDPOINT+'/api';
const apiUrl = {
  user: authUrl,
  session: authUrl,
  caso: registerUrl,
  familiar: registerUrl,
  lugar: registerUrl,
  militancia: registerUrl,
  familiarohermano: registerUrl,
  home: registerUrl+'/web',
  noticia: registerUrl+'/web',
  recurso: registerUrl+'/web',
  formulario: registerUrl+'/web',
  multimedia: registerUrl+'/web',
  testimonio: registerUrl+'/web',
};

export default {
  getList: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      order: field,
      page,
      per_page: perPage, 
      sort: order,
      ...params.filter,
    };
    if (params.filter.q)
      query.q = params.filter.q;
    if (resource === 'user') 
      query.attributes = ['id', 'username', 'email', 'phone', 'scope'];
    if (resource === 'caso') 
      query.attributes = ['id', 'nombre_caso', 'tipo_caso', 'estado_caso', 'estado'];
    
    if (resource === 'familiarohermano') {  
      const urlFamiliar = `${apiUrl[resource]}/familiar?${stringify(query)}`;
      query.attributes = ['id', 'nombre_caso', 'nombres', 'apellidos', 'estado'];
      const urlCaso = `${apiUrl[resource]}/caso?${stringify(query)}`;
      return Promise.all([
        httpClient(urlFamiliar),
        httpClient(urlCaso)
      ]).then(([familiares, casos]) => {
        const data = familiares.json.items.concat(casos.json.items);
        const total = familiares.json.total_count + casos.json.total_count;
        return {data, total};
      })
    }

    const url = `${apiUrl[resource]}/${resource}?${stringify(query)}`;
    return httpClient(url).then(({ headers, json }) => ({
      data: json.items,
      total: json.total_count,
    }));
  },

  getOne: (resource, params) => {
    if (resource === 'home') { 
      return httpClient(`${apiUrl[resource]}/${resource}`).then(({ json }) => ({
        data: {id: 0, ...json},
      }));
    }
    return httpClient(`${apiUrl[resource]}/${resource}/${params.id}`).then(({ json }) => ({
      data: json,
    }));
  },

  getMany: (resource, params) => {
    if (resource === 'familiarohermano')
      return async function() { return {data: []}}();

    return Promise.all(
      params.ids.map(id => httpClient(`${apiUrl[resource]}/${resource}/${id}`))
    ).then(responses => { 
      const list = responses.map(({ json }) => json );
      return { data: list };
    });
  },

  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      ...fetchUtils.flattenObject(params.filter),
      [params.target]: params.id,
      sort: order,
      page,
      per_page: perPage,
      order: field
    };
    const url = `${apiUrl[resource]}/${resource}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
        data: json.items,
        total: json.total_count,
    }));
  },

  update: (resource, params) =>
    httpClient(`${apiUrl[resource]}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: { id: params.id } })),

  updateMany: (resource, params) =>
    Promise.all(
      params.ids.map(id =>
        httpClient(`${apiUrl[resource]}/${resource}/${id}`, {
          method: 'PUT',
          body: JSON.stringify(params.data),
        })
      )
    ).then(responses => ({ data: responses.map(({ json }) => json.id) })),

  create: (resource, params) =>
    httpClient(`${apiUrl[resource]}/${resource}`, {
      method: 'POST',
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    })),

  delete: (resource, params) =>
    httpClient(`${apiUrl[resource]}/${resource}/${params.id}`, {
      method: 'DELETE',
    }).then(({ json }) => ({ data: json })),

  deleteMany: (resource, params) => 
    Promise.all(
      params.ids.map(id =>
        httpClient(`${apiUrl[resource]}/${resource}/${id}`, {
          method: 'DELETE',
        })
      )
    ).then(responses => ({ data: responses.map(({ json }) => json.id) })),
};
